module.exports = __webpack_public_path__ + "static/img/far2_c.f340a5e8.png";